import { currentEnvironment } from '../config/environments';

export const OFFLINE_LEGACY_ENVIRONMENT_KEY = 'legacy';

const normalizeApiUrl = (apiUrl: string): string =>
  apiUrl
    .trim()
    .toLowerCase()
    .replace(/\/+$/, '');

export const getOfflineEnvironmentKey = (): string => {
  const apiUrl = currentEnvironment.apiUrl || currentEnvironment.name || OFFLINE_LEGACY_ENVIRONMENT_KEY;
  return normalizeApiUrl(apiUrl) || OFFLINE_LEGACY_ENVIRONMENT_KEY;
};

